import React from "react";
import cx from "classnames";

type Props = {
  label: string;
  iconRight?: string;
  iconLeft?: string;
  disabled?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button: React.FC<Props> = ({
  label,
  className,
  onClick,
  iconRight,
  iconLeft,
  disabled,
}): JSX.Element => {
  return (
    <button
      className={cx("my-auto", className, disabled && "opacity-50")}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      <div className="flex flex-row items-center justify-center">
        {iconLeft && (
          <div className="flex flex-col mr-1">
            <img src={iconLeft} alt="icon" width={24} height={24} />
          </div>
        )}
        <div className="flex flex-col">{label}</div>
        {iconRight && (
          <div className="flex flex-col ml-1">
            <img src={iconRight} alt="icon" width={24} height={24} />
          </div>
        )}
      </div>
    </button>
  );
};

export default Button;
